<template>
  <div>
    <b-modal
      id="triggerasmnt"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      :visible="trigger"
      @hidden="$emit('close-modal')"
    >
      <div class="w-100">
        <div class="p-3 d-flex justify-content-between align-items-center">
          <div class="pff-modal-heading">
            {{ selectedCandidate.kanbanScheduled ? "Re-Trigger" : "Trigger" }}
            Assessment
          </div>
          <div class="d-flex align-items-center">
            <div
              v-if="!selectedCandidate.kanbanScheduled"
              class="mr-3 pointer"
              @click="$emit('show-alreadyinterviewed')"
            >
              <img
                class="mr-2 mb-1"
                src="../../../assets/img/already-interviewed.svg"
                alt=""
              />
              <span class="mt-1 already-font">Already Interviewed ?</span>
            </div>
            <div v-if="!selectedCandidate.kanbanScheduled" class="mr-3">
              <img src="../../../assets/img/line.svg" alt="" />
            </div>
            <div class="pointer" @click="$emit('close-modal')">
              <img
                class="rotate-on-hover"
                src="../../../assets/img/feedbackform/x-close.svg"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <hr class="m-0" />
      <div class="px-3 pt-3">
        <div class="triggerasmnt-container mt-2">
          <div class="triggerasmnt-modal-heads">Configuration</div>
          <div class="mt-2 triggerasmnt-container-cards">
            <div
              class="w-100 d-flex align-items-center justify-content-between"
            >
              <div class="w-90 text-truncate pr-2 ta-card-heads">
                {{ selectedProcess.configName }}
              </div>
              <div
                class="w-10 ta-card-view pointer"
                @click="showViewConfig = true"
              >
                View
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <div class="ta-card-sd">Start Date</div>
              <div class="ta-card-sd">End Date</div>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <div class="ta-card-date">
                {{
                  getConverted(selectedProcess.config.openTestdt).substring(
                    0,
                    10
                  ) | formatDate
                }}
              </div>
              <div class="ta-card-date">
                {{
                  getConverted(selectedProcess.config.closeTestdt).substring(
                    0,
                    10
                  ) | formatDate
                }}
              </div>
            </div>
            <div
              class="mt-3 ta-cards-config-msg d-flex align-items-center"
              v-if="expired"
            >
              <img
                src="../../../assets/img/newkanban/configmsg.svg"
                class="mr-1"
                alt=""
              />
              The configuration has expired, you cannot share the assessment.
            </div>
          </div>
        </div>
        <div class="triggerasmnt-container mt-2">
          <div class="triggerasmnt-modal-heads d-flex align-items-center">
            Test
            <span class="ta-card-sd" v-if="selectedCandidate.kanbanScheduled">
              (As this is the same round, you cannot select another test)
            </span>
            <span class="ta-card-sd" v-else-if="selectedProcess.randomizeTest"
              >&nbsp;(Test will be selcted automatically)</span
            >
            <span class="ta-card-sd" v-else
              >&nbsp;(Select test to trigger)</span
            >
          </div>
          <div class="trigr-asmnt-card-container-height">
            <div
              class="mt-2 mb-2"
              v-for="test in selectedProcess.selectedtests"
              :key="test.testID"
              @click="
                selectedProcess.randomizeTest ||
                expired ||
                selectedTest.testID == test.testID ||
                selectedCandidate.kanbanScheduled
                  ? ''
                  : (selectedTest = test)
              "
              :class="{
                pointer:
                  (!selectedProcess.randomizeTest &&
                    !selectedCandidate.kanbanScheduled) ||
                  triggeredAssessment(test),
                'ta-cards-test-selected': selectedTest.testID == test.testID,
                'ta-cards-test-disable-unselected defaultCursor':
                  (selectedTest.testID != test.testID &&
                    selectedCandidate.kanbanScheduled) ||
                  expired,
                'ta-cards-test ':
                  selectedTest.testID != test.testID &&
                  !selectedCandidate.kanbanScheduled,
              }"
            >
              <div class="d-flex triggerradio">
                <b-form-radio
                  v-if="!selectedProcess.randomizeTest"
                  name="some-radios"
                  v-model="selectedTest"
                  :value="test"
                  :disabled="selectedCandidate.kanbanScheduled"
                  :class="
                    selectedCandidate.kanbanScheduled &&
                    selectedTest.testID == test.testID
                      ? 'sel-radio'
                      : 'unsel-radio'
                  "
                >
                </b-form-radio>
                <div class="w-90">
                  <div class="d-flex align-items-center w-100">
                    <div class="w-50">
                      <div class="ta-cards-subheads">Test Name</div>
                      <div class="ta-card-heads text-truncate">
                        {{ test.name }}
                      </div>
                    </div>
                    <div class="w-50">
                      <div class="ta-cards-subheads">Topic Name</div>
                      <div class="ta-card-heads text-truncate">
                        {{ test.topicName }}
                      </div>
                    </div>
                  </div>
                  <hr class="my-2" />
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div>
                      <div class="ta-cards-subheads">Difficulty Level</div>
                      <div class="ta-card-heads text-center">
                        {{ test.difficultyLevel }}
                      </div>
                    </div>
                    <div>
                      <div class="ta-cards-subheads">Sections</div>
                      <div class="ta-card-heads text-center">
                        {{ test.numberOfSections }}
                      </div>
                    </div>
                    <div>
                      <div class="ta-cards-subheads">Questions</div>
                      <div class="ta-card-heads text-center">
                        {{ test.noOfQuestions }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0" />

      <div class="bluebtn d-flex justify-content-end mt-3 mr-3 mb-3">
        <b-button
          class="acs-cancelBtn-modal w-105px mr-3"
          @click="$emit('close-modal')"
          >Cancel</b-button
        >
        <div class="position-relative">
          <b-button
            v-if="!expired"
            class="acs-addBtn-modal w-105px"
            :disabled="
              expired ||
              (!selectedProcess.randomizeTest &&
                Object.keys(selectedTest).length == 0)
            "
            :class="{
              'trigger-loader-class':
                !selectedCandidate.kanbanScheduled && showLoader,
              'retrigger-loader-class':
                selectedCandidate.kanbanScheduled && showLoader,
              defaultCursor: showLoader,
              pointer: !showLoader,
            }"
            @click="showLoader ? '' : triggerAssess()"
            >{{
              showLoader
                ? ""
                : selectedCandidate.kanbanScheduled
                ? "Re-Trigger"
                : "Trigger"
            }}</b-button
          >
          <b-button
            v-else
            class="acs-addBtn-modal w-105px"
            :class="{
              'notification-loader-class': showLoader,
              defaultCursor: showLoader,
              pointer: !showLoader,
            }"
            @click="showLoader ? '' : sendNotification()"
            >{{ showLoader ? "" : "Send Notification" }}</b-button
          >

          <div
            v-if="showLoader"
            :class="
              expired
                ? 'notification-loader-pos'
                : selectedCandidate.kanbanScheduled
                ? 'retrigger-loader-pos'
                : 'trigger-loader-pos'
            "
          >
            <Loader />
          </div>
        </div>
      </div>
    </b-modal>
    <ViewConfig
      v-if="showViewConfig"
      :showModal="showViewConfig"
      :selectedProcess="selectedProcess"
      @close-modal="showViewConfig = false"
    />
  </div>
</template>

<script>
import {
  triggerAssessment,
  sendConfExpiredNoitification,
} from "../../../utils/apiFunctions";
import Loader from "../../fixedcomponents/Loader.vue";
import toast from "../../mixin/toast";
import ViewConfig from "./ViewConfig.vue";
import { convertTime } from "../../../controllers/workbench/helpers";
export default {
  name: "TriggerAssessment",
  data() {
    return {
      selectedTest: {},
      showLoader: false,
      showViewConfig: false,
    };
  },
  props: {
    type: Boolean,
    trigger: Boolean,
    selectedCandidate: Object,
    selectedProcess: Object,
    particularJob: Object,
    toRound: Number,
    remarks: String,
  },
  mixins: [toast],
  components: {
    Loader,
    ViewConfig,
  },
  computed: {
    expired() {
      const seldate = this.getConverted(
        this.selectedProcess.config.closeTestdt
      );
      let todayDate = new Date();
      todayDate = new Date(
        todayDate.getTime() - todayDate.getTimezoneOffset() * 60000
      )
        .toISOString()
        .replace(/\.\d{3}Z$/, ".000Z");
      if (seldate < todayDate) {
        return true;
      }
      return false;
    },
  },
  methods: {
    async sendNotification() {
      this.showLoader = true;
      try {
        let payload = {
          jobID: this.particularJob.jobID,
          testID: this.selectedTest.testID,
        };
        const res = await sendConfExpiredNoitification(payload);
        if (res.status === 200) {
          this.showLoader = false;
          this.$emit("close-modal");
          this.$nextTick(() => {
            this.dynamicToast(
              "success",
              `Successfully sent`,
              "Notification sent successfully"
            );
          });
        } else {
          this.showLoader = false;
          this.errorModal("Something went wrong!");
        }
      } catch (err) {
        this.showLoader = false;
        this.errorModal("Something went wrong!");
      }
    },
    getConverted(time) {
      return convertTime(time, "india");
    },
    async triggerAssess() {
      this.showLoader = true;
      let payload = {
        candidateID: [],
        panelList: [],
        testIDs: [],
        jobID: this.particularJob.jobID,
        customerID: this.particularJob.customerID,
        level: {},
      };
      if (!this.selectedProcess.randomizeTest) {
        payload.testIDs.push(this.selectedTest);
      }
      payload.candidateID.push(this.selectedCandidate.candidateID);
      if (this.toRound != null) {
        payload.level[this.selectedCandidate.candidateID] = parseInt(
          this.toRound
        );
        payload["recruiterRemarks"] = this.remarks;
      } else {
        if (this.selectedCandidate.kanbanLevel == 0) {
          payload.level[this.selectedCandidate.candidateID] =
            parseInt(this.selectedCandidate.kanbanLevel) + 1;
        } else {
          payload.level[this.selectedCandidate.candidateID] = parseInt(
            this.selectedCandidate.kanbanLevel
          );
        }
      }
      let panel = "cvinfra@simplify3x.com";
      payload.panelList.push(panel);
      if (this.$route.name == "VendorKanban") {
        payload.vendorID = this.$route.params.vendorID;
      }
      const res = await triggerAssessment(payload);
      if (res.status == 200) {
        this.showLoader = false;
        this.$emit("close-modal");
        this.$emit("update-details");
        this.$nextTick(() => {
          let value = this.selectedCandidate.kanbanScheduled
            ? "retriggered"
            : "triggered";
          var text = `Assessment has been ${value}  to candidate "${this.selectedCandidate.name}"`;
          this.dynamicToast(value, `Successfully ${value}`, text);
        });
      } else if (res.status === 409) {
        this.showLoader = false;
        this.errorModal(res.data.data.Detail);
      } else {
        this.showLoader = false;
        this.errorModal("Something went wrong!");
      }
    },
    triggeredAssessment(test) {
      let topicID =
        this.selectedCandidate.customerID[this.particularJob.customerID][
          this.particularJob.jobID
        ].topicID;
      let testID =
        this.selectedCandidate.customerID[this.particularJob.customerID][
          this.particularJob.jobID
        ].testID;
      if (testID == test.testID && topicID == test.topicID) {
        this.selectedTest = test;
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style>
.trigger-loader-class {
  opacity: 0.5;
  height: 29px;
  width: 100px;
}
.trigger-loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: 4px;
}

.notification-loader-class {
  opacity: 0.5;
  height: 29px;
  width: 160px;
}

.notification-loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: 30px;
}

.retrigger-loader-class {
  opacity: 0.5;
  height: 29px;
  width: 117px;
}
.retrigger-loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: 12px;
}
.triggerradio
  .custom-radio
  .custom-control-input:checked
  ~ .custom-control-label::after {
  background-image: none;
  border: 2px solid #20639b;
  border-radius: 50%;
}

.triggerradio .custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-width: 4px;
  border-color: #fff;
  background-color: var(--bluetheme);
}
.triggerradio .custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::after {
    top: 5px;
}
/* .triggerradio
  .custom-radio
  .custom-control-input:checked
  ~ .custom-control-label::after {
  top: 5px;
} */
.triggerradio .custom-control-label {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #3a3c40;
  line-height: 24px;
}

.triggerradio .custom-control-label::before {
  border: 2px solid #20639b;
}
.triggerradio .custom-control-input[disabled] ~ .custom-control-label,
.custom-control-input:disabled ~ .custom-control-label {
  color: #3a3c40;
}

.triggerradio .custom-control-input[disabled] ~ .custom-control-label::before,
.custom-control-input:disabled ~ .custom-control-label::before {
  /* top: 3px; */
  background-color: #ffffff;
}
.triggerradio
  .unsel-radio
  .custom-control-input[disabled]
  ~ .custom-control-label::before,
.custom-control-input:disabled ~ .custom-control-label::before {
  border: 1px solid #3a3c40;
  background: #72738e14;
}

.triggerradio
  .sel-radio
  .custom-control-input[disabled]
  ~ .custom-control-label::before,
.custom-control-input:disabled ~ .custom-control-label::before {
  color: #fff;
  border-width: 4px;
  border-color: #fff;
  background-color: var(--bluetheme);
}
</style>
